module.exports = __webpack_public_path__ + "static/media/bg_feedback.99a5f4a1.png";